var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgFiletypeMicrostation(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm11 3v-3h-9v16h12v-13z', fill: '#548ec7' }),
        React.createElement("path", { d: 'm10.747 12.35052a6.25546 6.25546 0 0 1 -1.3494-3.40207c-1.54217 2.37114-2.69879 2.57732-3.37349 1.4433l-.77111 3.60825h-1.253l2.0241-8.866 1.06024-.20618c.09638 0-.86747 3.91752.28915 4.32989s2.6988-5.25771 2.6988-5.25771l1.253.20619c-.86747 2.37113-.96385 4.74226.6747 6.90721z', fill: '#fff' }),
        React.createElement("path", { d: 'm11 0 3 3h-3z', fill: '#3d648a' })));
}
export default SvgFiletypeMicrostation;
